export default "__VITE_ASSET__rLLn476Z__"